/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：933
 */

module.exports = {
  imageBox: "style_imageBox__19dUX",
  edit: "style_edit___tEij",
  btn: "style_btn__2DRDE",
  form: "style_form__2kuji"
}
